import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 42DDDE71-7AA4-4A61-98F5-2A3B0AD486FF
 * name window-closed
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/window-closed.svg
 * tags
 * - Home Automation 
 */
export const WindowClosedIcon = createSvgIcon(<><path d="M6,11H10V9H14V11H18V4H6V11M18,13H6V20H18V13M6,2H18A2,2 0 0,1 20,4V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2Z" /></>, 'WindowClosedIcon');
export default WindowClosedIcon